module.exports = __webpack_public_path__ + "static/media/prepaid_b0a.26de372b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prepaid_b0a.png
// module id = 739
// module chunks = 21